import converters from "@/converters";
import graphqlClient from "@/GQLClient";
import type { ProfileFragment } from "@/graphql";
import {
  type EmployeeInput,
  Entity_Status,
  GetProfilesDocument,
  SaveProfileDocument,
} from "@/graphql/generated-types";
import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";

const save = async (employee: EmployeeInput) => {
  const response = await graphqlClient.mutate({
    mutation: SaveProfileDocument,
    variables: {
      employee,
    },
  });

  if (response.data?.user?.saveProfile?.success) {
    return response;
  }

  throw new SentryGraphQLError();
};

const getProfiles = async (): Promise<ProfileFragment[]> => {
  const response = await graphqlClient.query({
    query: GetProfilesDocument,
    variables: {
      filter: {
        status: [Entity_Status.Active],
      },
    },
  });

  if (response.data.institutions?.getMyInstitution) {
    return converters.profiles.toProfileFragment(
      response.data.institutions.getMyInstitution,
    );
  }

  throw new SentryGraphQLError();
};

export default {
  save,
  getProfiles,
};
